<div class="container">
    <div class="half-container">
        <p class="title">{{'TITLE_DEVICE_MANAGEMENT' | translate }}</p>
        <p class="subtitle">{{"SUBTITLE_DEVICE_MANAGEMENT" | translate}}</p>
    </div>
    <div class="half-container">
      
        <div class="divRigthContainer">
            
            <button mat-raised-button  color="primary" (click)="checkSelection()">
                <span class="continue-ico-btn"></span>
                           
                {{ 'TITLE_BTN_REPORT' | translate}}
                
            </button>
        <!--<mat-form-field  [style.width.px]=450 fxFlex="50"  appearance="outline">
        
        <input (keyup)="getSearchFiltr($event)"    matInput [ngModel]="search" name= "search"  placeholder="Search"/>
        <mat-icon   matSuffix>search</mat-icon>
      
        </mat-form-field>-->
        </div>
     

    </div>


</div>

<neoris-grid [ColumnsConfiguration]="gridColumnsConfiguration"  
[ShowChecks]="true" [Filter]="gFilter" [GridTitle]="'SUBTITLE_DEVICE_MANAGEMENT' | translate" 
[Data]="arrayGirdDeviceManagementGrid"   (cellClickEvent)="cellClick($event)"></neoris-grid>



<div>

</div>
